import { useState } from "react";

export type Tag = {
  id: string;
  text: string;
};

export const TagInput = ({ tags, setTags }: { tags: Tag[]; setTags: (tags: Tag[]) => void }) => {
  const [inputValue, setInputValue] = useState("");

  const handleAddTag = () => {
    if (inputValue.trim() && !tags.find((tag) => tag.text === inputValue.trim())) {
      setTags([...tags, { id: Date.now().toString(), text: inputValue.trim() }]);
      setInputValue("");
    }
  };

  const handleRemoveTag = (id: string) => {
    setTags(tags.filter((tag) => tag.id !== id));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2 border dark:border-border rounded-lg p-2">
      {tags.map((tag) => (
        <span
          key={tag.id}
          className="flex items-center gap-1 bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium"
        >
          {tag.text}
          <button
            type="button"
            onClick={() => handleRemoveTag(tag.id)}
            className="text-blue-700 hover:text-red-500 transition-colors"
          >
            ✕
          </button>
        </span>
      ))}
      <input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleAddTag}
        placeholder="Add emails..."
        className="flex-grow outline-none text-sm py-1 px-2"
      />
    </div>
  );
};
